import React from 'react';
import { styled, Col, Row } from '@teko/ui';
import { RatingStars } from '../RatingStars/RatingStars.es.js';
import { ProgressBar } from '../../../ProgressBar/ProgressBar.es.js';

const StyledRatingStars = styled(Col)`
  padding-right: 0px;
  min-width: 80px;
`;
const StyledProgressBar = styled(Col)(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.gray600};
  font-size: 12px;
  padding-left: 0px;
`);
const VoteCountCol = styled(Col)`
  padding-top: 6px;
`;
const StyledCol = styled(Col)`
  text-align: right;
`;
const calculatePercent = (use, total) => {
  return 100 * use / total || 0;
};
const RatingStatistic = ({
  stars,
  voteCount,
  totalRating
}) => {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(StyledRatingStars, {
    col: 3.5
  }, /* @__PURE__ */ React.createElement(RatingStars, {
    stars,
    readOnly: true
  })), /* @__PURE__ */ React.createElement(StyledProgressBar, {
    col: 8.5
  }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(VoteCountCol, {
    col: 9.5
  }, /* @__PURE__ */ React.createElement(ProgressBar, {
    barHeight: 4,
    progress: calculatePercent(voteCount, totalRating),
    barColor: "rgb(95, 231, 255)"
  })), /* @__PURE__ */ React.createElement(StyledCol, {
    col: 2.5
  }, /* @__PURE__ */ React.createElement("span", null, voteCount))))));
};

export { RatingStatistic };
